


















import { Component, Vue, Watch } from "vue-property-decorator";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { PermissionValue } from "@/enums/PermissionValue";
import UrlForm from "@/models/urlForm.model";

@Component({})
export default class NoFoundCookiesPage extends Vue {
  $authService: any;

  mounted() {
    
  }
  created() {}

  doLogOut() {
    localStorage.removeItem("id_token_obj");
    localStorage.removeItem("user");
    localStorage.removeItem("cookies");
    this.$authService.logout();
  }
}
